import { closest } from './dom-helpers'

export default function () {
  return function (scribe) {
    const subscriptCommand = new scribe.api.CommandPatch('subscript')
    
    /**
    * Chrome: Executing the subscript command inside a heading corrupts the markup.
    * Disabling for now.
    */
    // subscriptCommand.queryEnabled = function (...args) {
    //   const selection = new scribe.api.Selection()
    //   const headingNode = selection.getContaining((node) => {
    //     return (/^(H[1-6])$/).test(node.nodeName)
    //   })
    //
    //   return ::scribe.api.CommandPatch.prototype.queryEnabled(...args) && ! headingNode
    // }

    // TODO: We can't use STRONGs because this would mean we have to
    // re-implement the `queryState` command, which would be difficult.

    subscriptCommand.queryState = function () {
      const selection = new scribe.api.Selection()
      const range = selection.range
      let container

      if (!range) {
        return false
      }

      container = range.commonAncestorContainer

      if (container.nodeType === Node.TEXT_NODE) {
        container = container.parentNode
      }

      return !!closest(container, 'sub')
    }

    // remove orig impl
    scribe.commands.subscript = null
    scribe.commandPatches.subscript = subscriptCommand

  }
}
